export default "__VITE_ASSET__DmXif1dy__"